// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2kEj5","inner":"Footer_inner__1w7Vy","nextIcon":"Footer_nextIcon__2FqJ9","innerLeft":"Footer_innerLeft__JIetT"};